// Welcome — /welcome?token=… from the "you're approved" email. Posts the one-time token (a page, not a
// plain GET link, so email scanners that pre-open links can't use it up), then lands in the app.

import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthApi } from "../hooks/useApi.js";
import { useAuth } from "../auth/AuthProvider.jsx";
import { LoginShell } from "./Login.jsx";

export default function Welcome() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [error, setError] = useState("");
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false); // StrictMode runs effects twice in dev — the token only works once
  const cyber = typeof document !== "undefined" && document.documentElement.dataset.theme === "cyberpunk";

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) { setError("This sign-in link is incomplete. Open it from the email again."); return; }
    AuthApi.link(token)
      .then(async () => {
        await refresh();
        try { sessionStorage.setItem("tmc.boot", "1"); } catch { /* non-fatal */ }
        navigate("/", { replace: true });
      })
      .catch((err) => setError(err.body?.error || "Could not sign you in. Try again shortly."));
  }, [token, refresh, navigate]);

  return (
    <LoginShell onSubmit={(e) => e.preventDefault()} cyber={cyber}>
      <p className="login__tagline">Welcome to TMCChat</p>
      {error ? <div className="field__err">⚠ {error}</div> : <div className="login__notice">Signing you in…</div>}
      {error && <Link className="btn btn--primary btn--block" to="/login">Sign in</Link>}
    </LoginShell>
  );
}
